import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import firebase from "firebase/app";
import "firebase/auth";
import { appConfig } from "./../../firebase.init";
import { Link } from "react-router-dom";

if (!firebase.apps.length) {
  firebase.initializeApp(appConfig);
}

const Firebase = ({ handleSignIn }) => {
  const { register, handleSubmit } = useForm();
  const [errors, setErrors] = useState([]);
  const [pristine, setPristine] = useState(true);

  useEffect(() => {
    if (errors.length) {
      setPristine(false);
    }
  }, [errors]);

  const handleLogin = async (email, password) => {
    try {
      const result = await firebase
        .auth()
        .signInWithEmailAndPassword(email, password);
      handleSignIn(result?.user);
    } catch (err) {
      setErrors(["Invalid Email/Password"]);
      setPristine(false);
      handleSignIn(null);
    }
  };

  const onSubmit = async (data) => {
    if (!!data["remember"]) {
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => {
          handleLogin(data["email"], data["password"]);
        });
    } else {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
      handleLogin(data["email"], data["password"]);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "50vh" }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            name="email"
            className="form-control"
            aria-describedby="email"
            placeholder="Enter email."
            ref={register}
            required
            autoComplete="true"
            onChange={(e) => setErrors([])}
          />
        </div>
        <p></p>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Password"
            name="password"
            ref={register}
            onChange={(e) => setErrors([])}
            required
            autoComplete="true"
          />
        </div>
        <p></p>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="remember"
            ref={register}
          />
          <label className="form-check-label" htmlFor="remember">
            {" "}
            Remember me
          </label>
        </div>
        {!pristine && errors.length > 0 && (
          <React.Fragment>
            <p></p>
            <div className="form-text" style={{ color: "red" }}>
              {errors.map((err, idx) => (
                <span key={idx}>{err}</span>
              ))}
            </div>
          </React.Fragment>
        )}
        <div className="d-flex align-items-center justify-content-around mt-2">
          <button type="submit" className="btn btn-success">
            Sign In
          </button>
          <Link to="/">
            <button type="button" className="btn btn-primary">
              Home
            </button>
          </Link>
        </div>
      </form>
    </div>
  );
};

export default Firebase;
